export default "/moocrvUSD-MIM.930376a5d7ca6d73cdce0da2a561e1ef.png";